import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import DateInput from '../../DateInput.js';
import { Checkbox, Input } from '../../index.js';
import MoneyInput from '../../MoneyInput.js';
import { SectionContentPanel } from '../../PanelSection.js';
const parseInteger = (int) => Number(int);
const MethodInput = (props) => {
    const { byAmount, setByAmount, amount, setAmount, amountRaw, setAmountRaw, duration, setDuration, durationRaw, setDurationRaw, scheduledAmountChanges, setScheduledAmountChanges, scheduledAmountChangesRaw, setScheduledAmountChangesRaw, startDate, snapStartDate, dateFilter, } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(React.Fragment, null,
        React.createElement(SectionContentPanel, { active: byAmount, onClick: () => setByAmount(true) },
            React.createElement(Checkbox, { checkboxStyle: { fontSize: '1.3em' }, checkMark: true, checked: byAmount, placeholder: lang.paymentPlans.calculateByAmount, onChange: () => { } }),
            React.createElement(MoneyInput, { value: amountRaw, placeholder: lang.paymentPlans.amount, onChange: (e) => setAmountRaw(e), onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        setAmount(amountRaw);
                    }
                }, onBlur: () => setAmount(amountRaw), onFocus: () => {
                    if (!byAmount) {
                        setByAmount(true);
                    }
                }, button: amountRaw !== amount
                    ? {
                        value: lang.paymentPlans.save,
                        onClick: () => setAmount(amountRaw),
                    }
                    : undefined }),
            scheduledAmountChanges.map((change, index) => {
                const rawValue = scheduledAmountChangesRaw[index] ?? change.amount;
                const commitAmount = () => {
                    setScheduledAmountChanges((prev) => prev.map((c, i) => i === index ? { ...c, amount: rawValue } : c));
                };
                return (React.createElement(ScheduledAmountChangeRow, { key: index },
                    React.createElement(MoneyInput, { value: rawValue, placeholder: lang.paymentPlans.amount, onChange: (value) => {
                            setScheduledAmountChangesRaw((prev) => prev.map((v, i) => (i === index ? value : v)));
                        }, onKeyDown: (e) => {
                            if (e.key === 'Enter') {
                                commitAmount();
                            }
                        }, onBlur: () => commitAmount(), onFocus: () => {
                            if (!byAmount) {
                                setByAmount(true);
                            }
                        }, button: rawValue !== change.amount
                            ? {
                                value: lang.paymentPlans.save,
                                onClick: commitAmount,
                            }
                            : undefined }),
                    React.createElement(DateInput, { placeholder: lang.paymentPlans.scheduledAmountChangeFromDate, value: change.date, onChange: (d) => {
                            const snapped = snapStartDate(d);
                            setScheduledAmountChanges((prev) => prev.map((c, i) => i === index ? { ...c, date: snapped } : c));
                        }, minDate: startDate.toDate(), filterDate: dateFilter, allowNull: false }),
                    React.createElement(RemoveScheduledAmountChangeButton, { onClick: () => {
                            setScheduledAmountChanges((prev) => prev.filter((_, i) => i !== index));
                            setScheduledAmountChangesRaw((prev) => prev.filter((_, i) => i !== index));
                        }, "aria-label": "Remove" }, "\u00D7")));
            }),
            React.createElement("div", { style: { marginTop: '-15px' } },
                React.createElement(AddScheduledAmountChangeLink, { onClick: () => {
                        if (!byAmount) {
                            setByAmount(true);
                        }
                        const lastDate = scheduledAmountChanges[scheduledAmountChanges.length - 1]
                            ?.date ?? startDate;
                        setScheduledAmountChanges((prev) => [
                            ...prev,
                            {
                                amount: amount,
                                date: snapStartDate(lastDate.clone().add(1, 'month')),
                            },
                        ]);
                        setScheduledAmountChangesRaw((prev) => [...prev, amount]);
                    } }, lang.paymentPlans.addScheduledAmountChange))),
        React.createElement(SectionContentPanel, { active: !byAmount, onClick: () => setByAmount(false) },
            React.createElement(Checkbox, { checkboxStyle: { fontSize: '1.3em' }, checkMark: true, checked: !byAmount, placeholder: lang.paymentPlans.calculateByDuration, onChange: () => { } }),
            React.createElement(Input, { value: durationRaw, placeholder: lang.paymentPlans.entries, type: "number", onChange: (e) => setDurationRaw(e.target.value), onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        setDuration(parseInteger(durationRaw));
                    }
                }, onBlur: () => setDuration(parseInteger(durationRaw)), onFocus: () => {
                    if (byAmount) {
                        setByAmount(false);
                    }
                }, button: parseInteger(durationRaw) !== duration
                    ? {
                        value: lang.paymentPlans.save,
                        onClick: () => setDuration(parseInteger(durationRaw)),
                    }
                    : undefined }))));
};
export default MethodInput;
const ScheduledAmountChangeRow = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
`;
const RemoveScheduledAmountChangeButton = styled.button `
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 50%;
  color: ${THEME.TEXT_SUBTLE};
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;

  &:hover {
    background: #fdecea;
    border-color: #f4c4be;
    color: #c0392b;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px ${THEME.ACCENT_SURFACE_STRONG};
  }
`;
const AddScheduledAmountChangeLink = styled.p `
  cursor: pointer;
  font-weight: 900;
  color: ${THEME.COLOR_ACCENT};
  font-size: 0.8em;
`;
//# sourceMappingURL=MethodInput.js.map